import { useEffect } from 'react';

import { useDeps } from '@Contexts/DI';
import useNavigation from '@Navigation/useNavigation';

import type { FC, PropsWithChildren } from 'react';
import type { BasePage } from '@Types/Base';

interface PageProps {
  page?: BasePage;
}

const Page: FC<PropsWithChildren<PageProps>> = ({ children }) => {
  const { pathname } = useNavigation();
  const { eventManager } = useDeps();

  useEffect(() => {
    eventManager.dispatch('page.change', { pathname });
  }, [eventManager, pathname]);

  return children;
};

export default Page;
